/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Step_GenerateInputs */

const en_admin_funnel_step_generate = /** @type {(inputs: Admin_Funnel_Step_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clicked generate`)
};

/**
* | output |
* | --- |
* | "Clicked generate" |
*
* @param {Admin_Funnel_Step_GenerateInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_step_generate = /** @type {((inputs?: Admin_Funnel_Step_GenerateInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Step_GenerateInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_step_generate(inputs)
});
export { admin_funnel_step_generate as "admin.funnel.step.generate" }